import { IQuickToolDialogManagerInjectable, IQuickToolFontList } from '@src/slide/application/service/quick-tool-dialog-manager/core/quick-tool-dialog-manager.interface';
import QuickToolFontList from './quick-tool-font-list-injectable';

export class QuickToolDialogServiceInjectable implements IQuickToolDialogManagerInjectable {
    private FontList: React.ReactNode|undefined;

    public async getFontListFontListModule(): Promise<React.ReactNode|undefined> {
        if (!this.FontList) {  // B端没有这个入口，可以不加判断
            const { FontList } = (await import('@src/utils/fonts/sync-font-list-loader'));
            this.FontList = FontList;
        }
        return this.FontList;
    }

    public getQuickToolFontList(): IQuickToolFontList {
        return QuickToolFontList;
    }
}
